import { Outlet } from 'react-router-dom'
import { useEnforceLogin } from '@crossfit/auth'
import ReviewInvitePage from 'pages/TeamManagement/ReviewInvite'
import { useAffiliate } from 'hooks/useAffiliate'
import LockedOutPage from 'pages/LockedOut'
import { useAuth } from 'components/Auth'
import { Loader } from '@crossfit/ui'

export default function AuthorizedApp() {
  useEnforceLogin()

  const { user } = useAuth()
  const { selectedAffiliate: affiliateDetail } = useAffiliate()

  // NOTE: If we are still waiting for authentication show the loader so we don't erroneously show Ineligible or TOS Page
  if (!user) {
    return <Loader />
  }

  if (location.pathname.includes('staff/review')) {
    return <ReviewInvitePage />
  }

  if (affiliateDetail?.id && affiliateDetail.affiliateStanding !== 'good') {
    return <LockedOutPage />
  }

  return <Outlet />
}
